'use strict';

import angular from 'angular';

class GrpFeeFormCtrl {
  model = {
    name: '',
    isActive: true
  };
  // Auth; //TODO: add auth check

  constructor($state, $stateParams, LoaderSvc, GrpFeeSvc, GroupSvc,
    GroupAuthSvc, DatetimeSvc) {
    var groupId = $stateParams.groupId;
    this.groupId = groupId;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.GrpFeeSvc = GrpFeeSvc;
    this.LoaderSvc = LoaderSvc;

    var that = this;

    // fee types
    this.feeTypes = [
      {type: 'fee', name: 'Group Fee'}
    ];

    this.isCreate = $state.current.name.indexOf('new') !== -1;
    // create
    if(this.isCreate) {
      // authorization
      GroupAuthSvc.validatePermission(groupId, 'groupFee', 'C');

      this.submit = this.createGroupFee;
      that.headerText = 'New Group Dues/Fee';
      that.submitText = 'Create Group Dues/Fee';
      GroupSvc.getTimePeriods({groupId}).$promise.then(function(tp) {
        that.timePeriods = tp;
      });
      this.cancelSref = 'group.view.settings.groupFee.list';

    // edit
    } else {
      // authorization
      GroupAuthSvc.validatePermission(groupId, 'groupFee', 'U');

      this.submit = this.updateGroupFee;
      var gfId = $stateParams.gfId;
      that.gfId = gfId;
      that.headerText = 'Edit Group Dues/Fee';
      that.submitText = 'Update Group Dues/Fee';
      this.GrpFeeSvc.get({groupId, id: gfId}).$promise
        .then(function(gf) {
        // ensure amount dates are in proper format for update
          var amountTypesArray = ['amounts', 'adjustments'];
          for(var i in amountTypesArray) {
            var at = amountTypesArray[i];
            gf[at].map(DatetimeSvc.getFormDateRange);
          }

          that.model = angular.copy(gf);
          that.display = gf;
        });
      this.cancelSref = 'group.view.settings.groupFee.list';
    }
  }

  createGroupFee() {
    var that = this;
    that.LoaderSvc.start();
    var model = that.model;
    model.toGroupId = Number(that.groupId);
    that.GrpFeeSvc.create({groupId: that.groupId}, this.model).$promise
      .then(function(gf) {
        that.LoaderSvc.stopSuccess('Group Dues/Fee Created');
        that.$state.go('group.view.settings.groupFee.view', {gfId: gf.id});
      }).catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }

  updateGroupFee() {
    var that = this;
    that.LoaderSvc.start();
    // remove rels that cannot be edited
    var model = this.model;
    delete model.toGroup;
    delete model.timePeriod;
    delete model.groupType;
    this.GrpFeeSvc
      .update({groupId: that.groupId, id: that.gfId}, model).$promise
      .then(function() {
        that.$state
          .go('group.view.settings.groupFee.list', {gfId: that.gfId});
        that.LoaderSvc.stopSuccess('Group Dues/Fee Updated');
      })
      .catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }
}

GrpFeeFormCtrl.$inject = [
  '$state',
  '$stateParams',
  'LoaderSvc',
  'GrpFeeSvc',
  'GroupSvc',
  'GroupAuthSvc',
  'DatetimeSvc'
];

export default GrpFeeFormCtrl;
